import { render, staticRenderFns } from "./ListadoDescuentos.vue?vue&type=template&id=08107366"
import script from "./ListadoDescuentos.vue?vue&type=script&lang=js"
export * from "./ListadoDescuentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports